<vy-text-link
  [label]="textLinkConfiguration.XLSX.label"
  [iconClass]="textLinkConfiguration.XLSX.icon"
  [size]="iconSize"
  (handleClick)="exportBookingList('xlsx')"
></vy-text-link>
<vy-text-link
  class="marginLeft-s"
  [label]="textLinkConfiguration.CSV.label"
  [iconClass]="textLinkConfiguration.CSV.icon"
  [size]="iconSize"
  (handleClick)="exportBookingList('csv')"
></vy-text-link>
